import { IPaginationSet, ResponseModel, IEmailSentModel, IAdsModel } from "@/models";
import VetQuestApi from "../VetQuestApi";

export abstract class OpenRequestService {
  static BASE_URL: string = "admin/openrequest";
  static async GetOpenRequest(
    pageIndex: number,
    pageSize: number
  ): Promise<ResponseModel<IPaginationSet<IEmailSentModel>>> {
    let response = new ResponseModel<IPaginationSet<IEmailSentModel>>(
      0,
      {} as IPaginationSet<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}?pageIndex=${pageIndex}&pageSize=${pageSize}`
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IPaginationSet<IEmailSentModel>>(
        error.response.status,
        {} as IPaginationSet<IEmailSentModel>,
        error.response
      );
      return response;
    }
  }

  static async GetOpenRequestByEmail(
    email: string
  ): Promise<ResponseModel<Array<IEmailSentModel>>> {
    let response = new ResponseModel<Array<IEmailSentModel>>(
      0,
      {} as Array<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().get(
        `${this.BASE_URL}/email/${email}`
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IEmailSentModel>>(
        error.response.status,
        {} as Array<IEmailSentModel>,
        error.response
      );
      return response;
    }
  }

  static async SendMultipleMail(
    emailSentIds: number[]
  ): Promise<ResponseModel<Array<IEmailSentModel>>> {
    let response = new ResponseModel<Array<IEmailSentModel>>(
      0,
      {} as Array<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/SendMultipleMail`,
        emailSentIds
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IEmailSentModel>>(
        error.response.status,
        {} as Array<IEmailSentModel>,
        error.response
      );
      return response;
    }
  }

  static async OpenRequestBlacklistMail(
    emailSentIds: number[],
    fromBlacklist: boolean = false
  ): Promise<ResponseModel<Array<IEmailSentModel>>> {
    let response = new ResponseModel<Array<IEmailSentModel>>(
      0,
      {} as Array<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/OpenRequestBlacklistMail`,
        emailSentIds
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IEmailSentModel>>(
        error.response.status,
        {} as Array<IEmailSentModel>,
        error.response
      );
      return response;
    }
  }

  static async DeleteMultiple(
    emails: string[]
  ): Promise<ResponseModel<IEmailSentModel>> {
    let response = new ResponseModel<IEmailSentModel>(0, {} as IEmailSentModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/DeleteMultiple`,
        emails
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IEmailSentModel>(
        error.response.status,
        {} as IEmailSentModel,
        error.response
      );
      return response;
    }
  }

  static async RejectOpenRequest(
    emailId: string
  ): Promise<ResponseModel<IEmailSentModel>> {
    let response = new ResponseModel<IEmailSentModel>(0, {} as IEmailSentModel);
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/RejectOpenRequest`,
        emailId
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IEmailSentModel>(
        error.response.status,
        {} as IEmailSentModel,
        error.response
      );
      return response;
    }
  }

  static async DeleteOpenRequestAsync(id: number): Promise<ResponseModel<IEmailSentModel>> {
    let response = new ResponseModel<IEmailSentModel>(0, {} as IEmailSentModel);
    try {        
        const { data, status } = await VetQuestApi().delete(`${this.BASE_URL}/DeleteOpenRequest/${id}`);
        if (data && status === 200) {
            response = new ResponseModel(200, data);
        }
        return response;
    } catch (error) {
        response = new ResponseModel<IEmailSentModel>(
            error.response.status,
            {} as IEmailSentModel,
            error.response
        );
        return response;
    }
}

static async DeleteOpenRequestMultipleAsync(
    adIds: number[]
  ): Promise<ResponseModel<Array<IEmailSentModel>>> {
    let response = new ResponseModel<Array<IEmailSentModel>>(
      0,
      {} as Array<IEmailSentModel>
    );
    try {
      const { data, status } = await VetQuestApi().post(
        `${this.BASE_URL}/DeleteMultipleOpenRequest`,
        adIds
      );

      if (data && status === 200) {
        response = new ResponseModel(200, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<Array<IEmailSentModel>>(
        error.response.status,
        {} as Array<IEmailSentModel>,
        error.response
      );
      return response;
    }
}
}
